import React, { useEffect, useMemo } from "react";
import ReactDOM from "react-dom/client";
import reportWebVitals from "./reportWebVitals";
import { Provider as ReduxProvider } from "react-redux";
import store from "./redux/store";
import { getTheme } from "./assets/global/Theme-variable";
import { CssBaseline, ThemeProvider } from "@mui/material";
import { ColorModeProvider, useColorMode } from "./contexts/ColorModeContext";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import "./globalStyles.css";
import App from "./App";
import $ from "jquery";
// Expose jQuery globally so SignalR can find it
window.$ = $;
window.jQuery = $;

// Import SignalR AFTER jQuery is global
require("signalr");

const Provider = ({ children }) => {
  const offlineToast = React.useRef(null);
  const onlineToast = React.useRef(null);

  useEffect(() => {
    function onlineHandler() {
      onlineToast.current = toast.success("You are Online", {
        closeOnClick: false,
        autoClose: false,
      });
      toast.dismiss(offlineToast.current);
    }

    function offlineHandler() {
      offlineToast.current = toast.error("You are Offline", {
        closeOnClick: false,
        autoClose: false,
      });
      toast.dismiss(onlineToast.current);
    }

    window.addEventListener("online", onlineHandler);
    window.addEventListener("offline", offlineHandler);

    return () => {
      window.removeEventListener("online", onlineHandler);
      window.removeEventListener("offline", offlineHandler);
    };
  }, []);

  return <ReduxProvider store={store}>{children}</ReduxProvider>;
};

const ThemedApp = () => {
  const { mode } = useColorMode();
  const theme = useMemo(() => getTheme(mode), [mode]);

  return (
    <ThemeProvider theme={theme}>
      <CssBaseline />
      <ToastContainer
        autoClose={2000}
        position="top-center"
        theme={mode === "dark" ? "dark" : "light"}
      />
      <App />
    </ThemeProvider>
  );
};

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <Provider>
      <ColorModeProvider>
        <ThemedApp />
      </ColorModeProvider>
    </Provider>
  </React.StrictMode>
);

reportWebVitals();

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
//reportWebVitals();
